import React from 'react';
import qs from 'query-string';
import Translations from './Translations.js';
import './LoginButton.css';

class LoginButton extends React.Component {

  LOGIN_ADMIN_REDIRECT_URI = "https://{{URI}}/wp-json/pv_login/v1/pv-login-admin-oauth";

  constructor(props) {
   super(props);
   this.restore_ref = React.createRef();
   this.translations =  new Translations(props.locale);
  }

  get_redirect_url = () => {
    return this.LOGIN_ADMIN_REDIRECT_URI.replace("{{URI}}", document.location.host)
  };

  login_redirect = () => {
    window.location.href = "https://login.provida.digital/auth/realms/pro-vida/protocol/openid-connect/auth?client_id=sites-pantheon&redirect_uri="+this.get_redirect_url()+"&response_type=code";
  };

  restore_wordpress = () => {
    document.getElementById("loginform").style.display = "block";
    let error_element = document.getElementById("login_error");
    if(error_element){
      error_element.style.display = "block";
    }
    document.getElementById("nav").style.display = "block";
    this.restore_ref.current.style.display = "none";
  }

  render(){
    let params = qs.parse(window.location.search)
    let extraSpace = "";

    if(params.loggedout === "true"){
      extraSpace = "pv-login-extra-space";
    }

    let loginform = document.getElementById("loginform");

    return (
      <div className={`pv-login-form ${extraSpace}`}>
        <a className={`pv-login-button`} href="javascript: void(0);" onClick={this.login_redirect}><span className="pv-login-button-content"><img alt="PRÓ-VIDA Logo" src={this.props.pluginroot + "/ovo.png"}/>{this.translations.get_translation("login_button_content")}</span></a>
        <div ref={this.restore_ref} style={(loginform && this.props.fallback === "true" ? {display: "block"} : {display: "none"})} className={`pv-login-button-show-wordpress`}><a href="javascript: void(0)" onClick={this.restore_wordpress}>{this.translations.get_translation("login_switch_wordpress")}</a></div>
      </div>
    );
  }
}

export default LoginButton;
